module.exports = __webpack_public_path__ + "img/pleisure_bodyimage02.12d33677.jpg";